import { render, staticRenderFns } from "./CompetitionSummaryFilters.vue?vue&type=template&id=388bc680"
import script from "./CompetitionSummaryFilters.vue?vue&type=script&lang=js"
export * from "./CompetitionSummaryFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports